export interface PendingUserOptions {
  email: string
  firstName: string
  lastName: string
  gender: string
  password: string
  utmTerm: string
  utmContent: string
  utmMedium: string
  utmSource: string
  utmCampaign: string
  utmCampaigns: string
  gclid: string
}

export class PendingUser {
  readonly email: string

  readonly firstName: string

  readonly lastName: string

  readonly gender: string

  readonly password: string

  readonly utmTerm: string

  readonly utmContent: string

  readonly utmMedium: string

  readonly utmSource: string

  readonly utmCampaign: string

  readonly utmCampaigns: string

  readonly gclid: string

  constructor(props: PendingUserOptions) {
    this.email = props.email
    this.firstName = props.firstName
    this.lastName = props.lastName
    this.gender = props.gender
    this.password = props.password
    this.utmTerm = props.utmTerm
    this.utmContent = props.utmContent
    this.utmSource = props.utmSource
    this.utmMedium = props.utmMedium
    this.utmCampaign = props.utmCampaign
    this.utmCampaigns = props.utmCampaigns
    this.gclid = props.gclid
  }

  get payload() {
    return {
      email: this.email,
      firstName: this.firstName,
      lastName: this.lastName,
      gender: this.gender,
      password: this.password,
      utmTerm: this.utmTerm,
      utmContent: this.utmContent,
      utmSource: this.utmSource,
      utmMedium: this.utmMedium,
      utmCampaign: this.utmCampaign,
      utmCampaigns: this.utmCampaigns,
      gclid: this.gclid,
    }
  }

  toJsonStringify() {
    const asPayload = this.payload
    delete asPayload.password
    return JSON.stringify(asPayload)
  }
}
